import { getAuth, randomRange, getCookies } from '~/utils'
import api from './fetch'
import Cookies from 'js-cookie'

interface ApiOptions {
  params?: any
  data?: any
}

export const getConfig = (options: ApiOptions) => {
  return api.get('/api/getCacheForView', options.data)
}

export const uploadDiskFiles = ({
  path,
  headers,
  data,
  signal,
  onUploadProgress,
}: {
  path: string
  data: any
  headers: any
  onUploadProgress: any
  signal?: any
}) => {
  return api.post(`/diskApi/file/shardUpload?path=${path}`, data, {
    headers: headers,
    onUploadProgress,
    signal,
  })
}

export const mergeDiskFiles = ({
  path,
  fileName,
  headers,
}: {
  path: string
  fileName: string
  headers: any
}) => {
  return api.post(
    `/diskApi/file/uploadShardMerge?path=${path}&fileName=${fileName}`,
    {},
    {
      headers: headers,
    }
  )
}

export const downloadDiskFiles = async ({
  params,
  headers,
  onprocess,
  onsuccess,
  onfail,
}: {
  params: {
    path: string
    fileName: string
    totalShard: number
    shardIndex: number
    fileMD5: string
  }
  headers: any
  onprocess: (now: number, all: number) => void
  onsuccess: (data: any) => void
  onfail?: (err: any) => void
}) => {
  const res = (await fetch(
    `${
      process.env.NEXT_PUBLIC_DISK_API
    }/file/shardDownload?path=${encodeURIComponent(
      params.path
    )}&fileName=${encodeURIComponent(params.fileName)}&totalShard=${
      params.totalShard
    }&shardIndex=${params.shardIndex}&fileMD5=${params.fileMD5}`,
    {
      method: 'post',
      headers: {
        from: 'web',
        device_id: randomRange(20, 20),
        Authorization: getAuth(),
        'gate-token': Cookies.get('gate-token') || '',
        ...headers,
      },
    }
  )) as any
  if (res.ok) {
    const reader = res.body.getReader()
    const contentLength = +res.headers.get('Content-Length')
    let receivedLength = 0
    let chunks = []
    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        break
      }
      chunks.push(value)
      receivedLength += value.length
      onprocess(receivedLength, contentLength)
    }
    let blob = new Blob(chunks)
    onsuccess(blob)
    return blob
  } else {
    onfail?.(res)
    return res
  }
}

export const getDeepseekMessage = (params: any, options: any) => {
  const headers: any = {
    'Content-Type': 'application/json',
    from: 'web',
    'app-code': 'trade',
    Authorization: getAuth(),
  }

  const cookies = getCookies(document.cookie)
  if (cookies['gate-token'] && cookies['gate-token'] !== 'null') {
    headers['gate-token'] = cookies['gate-token']
  }

  return fetch(
    process.env.NEXT_PUBLIC_API + '/langchain-stream/ai/conversation',
    {
      method: 'POST',
      headers,
      signal: options?.signal,
      body: JSON.stringify(params),
    }
  )
}
